module.exports = __webpack_public_path__ + "static/media/home.d3f0b012.jpg";